import React from 'react';
import { Link } from 'react-router-dom';
import AnimatedBanner from '../components/AnimatedBanner';
import WorkflowIllustration from '../components/WorkflowIllustration';
import ScrollAnimation from '../components/ScrollAnimation';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Workflow Illustration Section - First View */}
      <section className="workflow-hero-section">
        <div className="container">
          <WorkflowIllustration />
        </div>
      </section>

      {/* Animated Banner Section */}
      <AnimatedBanner />

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-tagline">
                <p className="tagline-text">
                  Effortless Records, Accurate Data Make Collection So Easy!!!
                </p>
              </div>
              <h1 className="hero-title">
                CableBiz <span className="highlight">Customer App</span>
              </h1>
              <p className="hero-description">
                The best available companion for your Cable TV with range of functionalities. 
                Manage your plans, track complaints, and pay bills online effortlessly.
              </p>
              <div className="hero-actions">
                <a href="https://admin.cablebiz.in/login/newregistration" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
                <Link to="/services" className="btn btn-outline">
                  Learn More
                </Link>
              </div>
            </div>
            <div className="hero-image">
              <div className="hero-card">
                <div className="card-glow"></div>
                <div className="card-icon-wrapper">
                  <div className="card-icon">📱</div>
                  <div className="icon-particles">
                    <span className="particle">✨</span>
                    <span className="particle">⭐</span>
                    <span className="particle">💫</span>
                  </div>
                </div>
                <h3>Mobile App</h3>
                <p>Available on iOS and Android</p>
                <div className="app-badges">
                  <span className="badge">iOS</span>
                  <span className="badge">Android</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h2 className="section-title">Customer App Features</h2>
            <p className="section-subtitle">
              Everything you need to manage your cable TV subscription in one place
            </p>
          </ScrollAnimation>
          <div className="features-grid">
            <ScrollAnimation delay={100}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">📋</div>
                </div>
                <h3>Plan Management</h3>
                <p>View and manage your cable TV plans with ease. Switch between packages anytime.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={150}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">📞</div>
                </div>
                <h3>Complain Tracker</h3>
                <p>Track your complaints in real-time. Get updates on service requests instantly.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={200}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">💳</div>
                </div>
                <h3>Online Bill Payment</h3>
                <p>Pay your bills securely online. Multiple payment options available.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={250}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">🚨</div>
                </div>
                <h3>Complain Raise Option</h3>
                <p>Raise service complaints directly from the app. Quick and easy resolution.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={300}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">📊</div>
                </div>
                <h3>Usage Analytics</h3>
                <p>Monitor your viewing patterns and data usage with detailed analytics and insights.</p>
              </div>
            </ScrollAnimation>
            <ScrollAnimation delay={350}>
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <div className="feature-icon-bg"></div>
                  <div className="feature-icon">🔔</div>
                </div>
                <h3>Smart Notifications</h3>
                <p>Get instant alerts for bill due dates, plan renewals, and important updates.</p>
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </section>

      {/* Operator Features Section */}
      <section className="operator-features section">
        <div className="container">
          <ScrollAnimation delay={0}>
            <h2 className="section-title">For Local Cable Operators</h2>
            <p className="section-subtitle">
              Complete billing and management solution for cable TV operators
            </p>
          </ScrollAnimation>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">⚙️</div>
              <h3>Plan Management</h3>
              <p>Create and manage multiple subscription plans with flexible pricing options.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Customer Management</h3>
              <p>Comprehensive subscriber database with detailed customer information.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Daily/Weekly/Monthly Reports</h3>
              <p>Generate detailed reports for better business insights and decision making.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📺</div>
              <h3>Running Packages</h3>
              <p>Track active customer packages and subscription status in real-time.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📡</div>
              <h3>Broadcaster Bouquet Selection</h3>
              <p>Select and manage broadcaster bouquets with online payment integration.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>Collection Agent App</h3>
              <p>Mobile app for collection and service agents to manage operations on the go.</p>
            </div>
          </div>
          <div className="section-cta">
            <p className="cta-text">
              The completeness of this product with all required reports is phenomenal.
            </p>
            <div className="cta-buttons">
              <Link to="/plans" className="btn btn-primary">
                View Plans
              </Link>
              <Link to="/contact" className="btn btn-outline">
                Request Demo
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section bg-gradient">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Get Started?</h2>
            <p className="cta-description">
              Join thousands of cable operators and customers using CableBiz for seamless billing and management.
            </p>
            <div className="cta-buttons">
              <a href="https://admin.cablebiz.in/login/newregistration" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
                Register Now
              </a>
              <Link to="/contact" className="btn btn-outline" style={{background: 'white', color: 'var(--primary-color)'}}>
                Contact Sales
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;

